import markApplications from "./markApplications";


const markApplicationService = [
    {
        matcher: 'markApplications',
        reply: config => {
            return [200, markApplications];
        }
    },
    {
        matcher: /markApplications\/(.*)/,
        reply: config => {
            const id = /markApplications\/(.*)/.exec(config.url)[1];
            const markApplication = markApplications.find(markApplication => markApplication.uuid === id);
            return [200, markApplication];
        }
    }
]

export default markApplicationService;